import { Vue } from 'vue-class-component';
import { NavListState } from '@/constant/computerType';

export class JumpLink extends Vue {
    jumpLink(item: NavListState) {
        if (item.link_type === 'micro') {
            this.$router.push({
                path: '/portalPage/Home',
                query: {
                    id: item.link_id
                }
            })
        } else if(item.link_type === 'course') {
            this.$router.push({
                path: '/portalPage/CourseDetail',
                query: {
                    ...this.$route.query,
                    courseId: item.link_id,
                    type: item.type
                }
            })
        } else if(item.link_url) {
            open(item.link_url, item.link_target || '_blank');
        }
    }
}